import { type FC } from 'react';

import PayByNabTransact, { type PayByNabTransactProps } from '../Payment/PayByNabTransact';

const NabTransactPayment: FC<PayByNabTransactProps> = ({ isValid, setErrors, options }) => {
  return (
    <PayByNabTransact
      isValid={isValid}
      setErrors={setErrors}
      options={options}
    />
  );
};

export default NabTransactPayment;
